export const LOADING = 'LOADING'
export const GET_ALL_TS_DEALERS = 'GET_ALL_TS_DEALERS'
export const GET_SINGLE_TS_DEALER = 'GET_SINGLE_TS_DEALER'
export const UPDATE_TS_DEALER = 'UPDATE_TS_DEALER'
